import * as z from 'zod';

/** Sort direction shared across all list endpoints. */
export const sortDirectionSchema = z.enum(['asc', 'desc']);
export type SortDirection = z.infer<typeof sortDirectionSchema>;

/**
 * Generic paginated list envelope. Entity APIs return `PaginatedResult<T>`.
 * Defined as a schema factory so individual entities can validate the full
 * response shape against their own item schema.
 */
export function paginatedSchema<T extends z.ZodType>(item: T) {
  return z.object({
    data: z.array(item),
    meta: z.object({
      page: z.number().int().positive(),
      pageSize: z.number().int().positive(),
      total: z.number().int().nonnegative(),
      totalPages: z.number().int().nonnegative(),
    }),
  });
}

export interface PaginatedResult<T> {
  data: T[];
  meta: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

/** Common list query parameters consumed by every server-driven table. */
export interface ListParams {
  page: number;
  pageSize: number;
  sortBy?: string | undefined;
  sortDir?: SortDirection | undefined;
}
